import React from "react";
import withProviders from "../../hooks/withProviders";
import { FilterProvider, FeeManagementDefaultFilters } from "../../hooks/FilterContext";
import HeadOfficeFeeManagement from "../../features/headofficefeemanagement";
const FeeManagementPage = () => <HeadOfficeFeeManagement />

export default withProviders([FilterProvider, { defaultFilters: FeeManagementDefaultFilters, filterStore: 'admin.management.fees' }])(FeeManagementPage);